export default "__VITE_ASSET__kj91dt5f__"